import { getErrorMsgAndCode, validateInput } from "./FrontendHelpers";
import api from "./axios";

const checkInput = (Header, Body, ReceiverIDs) => {
  return validateInput([
    {
      Name: "Message Header",
      Value: Header,
      Type: "string",
      MinLength: 0,
      MaxLengthType: "detail",
      OnlyCheckLength: true,
    },
    {
      Name: "Message Body",
      Value: Body,
      Type: "string",
      MinLength: 1,
      MaxLengthType: "largeDetail",
    },
    { Name: "Receiver", Value: ReceiverIDs, Type: "array" },
  ]);
};

export async function GetMessages() {
  try {
    console.log("Get messages called in hook");
    const response = await api.get("/getMessages");
    const result = response.data;
    console.log("Got messages  in hook:", result);

    return [result, null];
  } catch (error) {
    console.log("Got messages error in hook:", error);

    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function SendAnnouncement(Header, Body, Receivers) {
  try {
    const data = { Header, Body, Receivers };

    const inputError = checkInput(Header, Body, Receivers);
    if (inputError.errCode !== 0) return [null, inputError];

    const response = await api.post("/sendAnnouncement", data);

    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetMessageData(id) {
  try {
    const data = { ID: id };
    const response = await api.post("/getMessageInfo", data);
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function GetUnreadMessageCount() {
  try {
    const response = await api.get("/getUnreadMessageCount");
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function SendEmployeeRequest(Body, ReceiverIdentifier) {
  try {
    const data = { Body, ReceiverIdentifier };
    console.log("Request msg data:", ReceiverIdentifier, Body);
    const response = await api.post("/sendEmployeeRequest", data);
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function DeleteMessages(id) {
  try {
    const data = { IDs: id };
    const response = await api.post("/deleteMessages", data);
    const result = response.data;
    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function CheckForMessage(id) {
  try {
    const data = { ID: id };
    const response = await api.post("/checkForMessage", data);

    const result = response.data;
    if (result[0]) {
      return [true, null];
    }

    return [false, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
